// extracted by mini-css-extract-plugin
module.exports = {"link":"Channels_link__3IXQp"};